import AgeFilterComponent, { OtherAgeElementType } from "./components/ageFilterComponent";
import DateIntervalFilterComponent from "./components/dateIntervalFilterComponent";
import GenderFilterComponent from "./components/genderFilterComponent";
import {useSelector,useDispatch} from 'react-redux'
import './filterWrapperStyle.css'
import { getEvdaFranceAgeFilterState, getEvdaFranceGenderFilterState } from "../../redux/selectors/filterSelector";
import { SelectedAge } from "../../models/SelectedAge";
import { FilterAction } from "../../redux/states/filterState";
import { SelectedGender } from "../../models/SelectedGender";
export type Props = {
    maxDate:number
}
const EvdaFranceFilterWrapper:React.FC<Props>=({maxDate})=>{
        const dispatch = useDispatch()
        const agerFilter = useSelector(getEvdaFranceAgeFilterState)
        const genderFilter = useSelector(getEvdaFranceGenderFilterState)
        

        const onsetAgeSelectionHandler=(selection:SelectedAge)=>{
            dispatch(FilterAction.SetEvdaFranceAgeSelection(selection))
        } 
        const onSetCustomAge=(age:number)=>{
            dispatch(FilterAction.SetEvdaFranceCustomSelectedAge(age))
        }
        const onSetGenderSelection=(gender:SelectedGender) =>{
            dispatch(FilterAction.SetEvdaFranceGenderInSelection(gender))
        }
    return(<>
        <AgeFilterComponent 
            selectedAge={agerFilter.seletedAge} 
            customAgeElement={OtherAgeElementType.customElement}
            customSelectedAge={agerFilter.customSelectedAge}
            onSetCustomAge={onSetCustomAge}
            onSetSelection={onsetAgeSelectionHandler}/>
         <GenderFilterComponent 
            selectedGender={genderFilter.selectedGender} 
            setSelectectionHandler={onSetGenderSelection}/>
        <DateIntervalFilterComponent  SliderMax={maxDate} SliderMin={1946}/>
        </>)
}

export default EvdaFranceFilterWrapper;